import { useRouterState } from '@tanstack/react-router';

/**
 * The route the person is on.
 *
 * The pathname is what the API matches against when it chooses the page's skill,
 * so it is also what the panel sends as the `route`. Reading it from the router
 * rather than from a prop means the panel cannot be mounted on a page whose route
 * it does not know about.
 */
export function useAssistantRoute(): string {
  return useRouterState({ select: (state) => state.location.pathname });
}
